import { render, staticRenderFns } from "./CadastroFornecedorEndereco.vue?vue&type=template&id=f98bee72"
import script from "./CadastroFornecedorEndereco.vue?vue&type=script&lang=js"
export * from "./CadastroFornecedorEndereco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports